import React, { useEffect } from "react";
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-loading-skeleton/dist/skeleton.css'

import MyRouts from "./Routers/routes";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import store from "store";
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import { useTranslation } from 'react-i18next';
import { BrowserRouter, Routes, Route, Navigate, useHistory } from "react-router-dom";
import ChatBox from "Pages/ChatBox/ChatBox";
import { I18nextProvider } from 'react-i18next';
import i18n from './lngProvider/i18n';

function App() {

  let lang = localStorage.getItem('lang')
  const { i18n, t } = useTranslation();

 /**
      * Used for render selected language preference
      */
  useEffect(() => {
    if (lang == "ar") {
      i18n.changeLanguage("ar");
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      i18n.changeLanguage("en");
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }

  }, [])




 
  return (
    <div className="App">
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <GoogleOAuthProvider
            clientId={`554948056563-h60g8tj6215u67fcglpfnc6r3nhieguq.apps.googleusercontent.com`}
          >
            <BrowserRouter>
              <MyRouts />
              <ChatBox />
            </BrowserRouter>
          </GoogleOAuthProvider>
        </Provider>
      </I18nextProvider>


    </div >
  );
}

export default App;
